<section class="blog__header py-[8px] sticky top-[0px] z-[30]">
  <app-category-section [selected]="category"></app-category-section>
  <app-tag-section *ngIf="!!category" [tags]="category.tags"></app-tag-section>
</section>
<app-posts-section [posts]="posts"></app-posts-section>
<app-drawer-top-component drawerId="drawer-category-list" title="Danh mục">
  <ul>
    @for (c of categories; track c.id) {
    <li class="blog__list-item h-[60px] flex items-center border-b-[1px]" data-drawer-hide="drawer-category-list">
      <a
        [routerLink]="`/blog/${c.slug}/${c?.tags?.[0]?.slug}`"
        class="flex items-center gap-[8px] rtl:space-x-reverse w-full"
      >
        <div class="shrink-0">
          <span class="text-[22px]">{{c.icon}}</span>
        </div>
        <div class="flex-1 min-w-0">
          <span class="blog__list-item-title truncate">{{c.name}}</span>
        </div>
        <div *ngIf="category?.slug === c.slug" class="inline-flex items-center text-base font-semibold">
          <svg
            class="w-6 h-6 text-gray-800"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M5 11.917 9.724 16.5 19 7.5"
            />
          </svg>
        </div>
      </a>
    </li>
    }
  </ul>
</app-drawer-top-component>
